// Enterprise standard empty state — see /app/memory/DESIGN_SYSTEM.md §18
import { cn } from '@/lib/utils';

export const EmptyState = ({ icon: Icon, title, description, action, className, testid }) => (
  <div
    data-testid={testid}
    className={cn('flex flex-col items-center justify-center border border-dashed border-zinc-300 rounded-lg bg-zinc-50/50 p-10 text-center', className)}
  >
    {Icon && <Icon size={32} weight="duotone" className="text-zinc-400 mb-2" />}
    <p className="text-sm font-medium text-zinc-900">{title}</p>
    {description && <p className="text-sm text-zinc-500 mt-1">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
